export const formatDate = (timestamp) => {
  return new Date(timestamp).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatPrice = (price, currency = '$') => {
  // payablePrice appears to be already in dollars (like in PDF template)
  const priceValue = typeof price === 'string' ? parseFloat(price) : price;

  return `${currency}${priceValue.toFixed(2)}`;
};

export const getOrderStatusColor = (orderStatus) => {
  // orderStatus is a string number: "1" = completed, "0" = pending, etc.
  switch (orderStatus) {
    case '1':
      return 'text-green-600';
    case '0':
      return 'text-orange-600';
    case '2':
      return 'text-red-600';
    default:
      return 'text-gray-600';
  }
};

export const getOrderStatusText = (orderStatus) => {
  switch (orderStatus) {
    case '1':
      return 'Completed';
    case '0':
      return 'Pending';
    case '2':
      return 'Cancelled';
    default:
      return 'Unknown';
  }
};

export const getOrderTypeText = (orderType) => {
  switch (orderType) {
    case '1':
      return 'Pickup';
    case '2':
      return 'Delivery';
    case '3':
      return 'Dine In';
    default:
      return 'Unknown';
  }
};

export const getOrderTypeStyle = (orderType) => {
  switch (orderType) {
    case '1': // Pickup / Walk-in
      return 'bg-green-50 text-green-700';
    case '2': // Delivery
      return 'bg-blue-50 text-blue-700';
    case '3': // Dine In
      return 'bg-red-50 text-red-700';
    default:
      return 'bg-gray-50 text-gray-700';
  }
};

export const getPaymentMethodText = (paymentType) => {
  return paymentType === '0' ? 'Cash' : 'Card';
};

export const getCardUrl = (cardType) => {
  if (cardType === '6')
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/visasvg.svg`;
  else if (cardType === '5')
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/mastercardsvg.svg`;
  else if (cardType === '2')
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/amexsvg.svg`;
  else
    return `${window.storeConfigInitial?.storageBaseUrl}/assets/credit-card-2.svg`;
};
